import { render } from "./CorteServicio.vue?vue&type=template&id=5617b792&scoped=true"
import script from "./CorteServicio.vue?vue&type=script&lang=js"
export * from "./CorteServicio.vue?vue&type=script&lang=js"

import "./CorteServicio.vue?vue&type=style&index=0&id=5617b792&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5617b792"]])

export default __exports__